import StatCard from 'components/atoms/StatCard';
import { GrowthMarginBridgeCardData } from './data/GrowthMarginBridgescardData';
import GrowthBridgesChart from './GrowthBridgesChart';
import DecompositionChart from './DecompositionChart';
import useGrowthMarginBridgesData from './hooks/useGrowthMarginBridgesData';
import { Skeleton } from 'antd';

const GrowthMarginBridges = () => {
    const { cardsData, isPending } = useGrowthMarginBridgesData();
    return (
        <>
            <div
                className={`border border-borderLinePurpule bg-white p-4  rounded-lg            
            `}
            >
                <div className="mt-4 flex flex-col border border-[#0000000F] rounded-lg px-4 py-4 w-full">
                    <p className="font-semibold text-2xl">{'Growth / Margin Bridges'}</p>
                    <div className="flex flex-row gap-4">
                        {isPending ? (
                            <div className="mt-2">
                                <Skeleton active={true} paragraph={{ rows: 1, width: 256 }} title={{ width: 256 }} />
                            </div>
                        ) : (
                            cardsData.map((cardData) => {
                                return (
                                    <StatCard
                                        metricName={cardData?.metricName}
                                        absoluteValue={cardData?.absoluteValue}
                                        unit={cardData?.unit}
                                    />
                                );
                            })
                        )}
                    </div>
                    <div className="mt-4 flex flex-col border border-[#0000000F] rounded-lg px-4 py-4 w-full">
                        <GrowthBridgesChart />
                    </div>

                    <div className="mt-4 flex flex-col border border-[#0000000F] rounded-lg px-4 py-4 w-full">
                        <DecompositionChart />
                    </div>
                </div>
            </div>
        </>
    );
};

export default GrowthMarginBridges;
